import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "St. Cloud",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of St Cloud Minnesota cityscape with the Mississippi River, downtown historic buildings, St Cloud State University campus, Sauk Rapids bridge, autumn trees along the river, warm golden hour lighting, professional photography, no readable text or signs",
  heroImageSeq: "st-cloud-mn-hero",
  heroDescription:
    "Business trip to Europe in two weeks? Study abroad semester starting soon? Family vacation to Mexico and your passport just expired? We help St. Cloud residents — from St. Cloud State students and faculty to central Minnesota business owners and manufacturing workers — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  geoPosition: "45.5579; -94.1632",
  geoPlacename: "St. Cloud, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/st-cloud/",
  localAreaTitle: "Serving St. Cloud & Central Minnesota",
  localAreaText: [
    "St. Cloud, Minnesota is the anchor of central Minnesota — a thriving city of roughly 70,000 residents that serves as the commercial, educational, and cultural hub for a region stretching from the Brainerd Lakes area to the Minnesota River valley. The city is home to St. Cloud State University, one of the largest public universities in the state, which creates a significant population of students, faculty, and international scholars who need passport services for study abroad, research trips, and academic conferences.",
    "The local economy extends well beyond education. St. Cloud is a major manufacturing and healthcare center for central Minnesota, with companies producing medical devices, food products, and industrial equipment. Many of these businesses have international clients and suppliers, creating a steady stream of business travelers who need expedited passports. The city's location at the junction of Interstate 94 and Highway 10 makes it a natural transportation hub for the region.",
    "St. Cloud's community also includes a significant population of immigrants and first-generation Americans who travel to visit family abroad. These travelers often need passport renewals, child passports, or name change services on compressed timelines. The closest regional passport agency is in the Twin Cities, nearly 70 miles away — making a local expedited service even more valuable for St. Cloud residents who cannot make multiple trips to Minneapolis.",
  ],
  nearbyCities: [
    { name: "St. Cloud", zips: "56301, 56302, 56303, 56304" },
    { name: "Sartell", zips: "56377" },
    { name: "Waite Park", zips: "56387" },
    { name: "Sauk Rapids", zips: "56379" },
    { name: "St. Joseph", zips: "56374" },
    { name: "Little Falls", zips: "56345" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home or dorm in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "St. Cloud & Central Minnesota Coverage",
  serviceAreaDescription: "Serving Stearns, Benton, and Sherburne counties with overnight courier pickup",
  faqs: [
    {
      q: "How fast can I get a passport in St. Cloud, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in St. Cloud can take 2–6 months. For students, business travelers, and families with international plans, that timeline is not viable.",
    },
    {
      q: "Can St. Cloud State students get a passport for study abroad quickly?",
      a: "Yes — study abroad students are one of our most common client types in St. Cloud. Many students receive their program acceptance with only 3–6 weeks before departure. We regularly process expedited passports for students on compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "What if my passport expires before a family visit to my home country?",
      a: "Many St. Cloud residents visit family abroad. If your passport is close to expiring, we recommend expedited processing. Standard mail-in renewal typically takes 2–6 months, which may not align with your travel dates.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most St. Cloud travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in St. Cloud. Start your order online, follow the checklist, and ship your documents overnight from anywhere in central Minnesota.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "Sarah L.",
      location: "St. Cloud, MN",
      rating: 5,
      text: "I was accepted to a study abroad program in Spain with only four weeks before departure. My passport was expired. Fast Passport Center processed my renewal in five business days. I made my flight and had an incredible semester. Their team understood the urgency of student travel.",
      service: "Passport Renewal",
    },
    {
      name: "The Patel Family",
      location: "Sartell, MN",
      rating: 5,
      text: "We needed to visit family in India and discovered our son's passport had expired. Fast Passport Center handled his child passport expedited in seven business days. We made our trip and got to celebrate a family wedding together. Thank you for the professional service.",
      service: "Child Passport",
    },
    {
      name: "Michael D.",
      location: "St. Cloud, MN",
      rating: 5,
      text: "I had a business trip to Germany with two weeks notice. My passport was within three months of expiration. Fast Passport Center processed my renewal in four business days. I attended the trade show and secured two new clients. Their service was excellent.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Rochester", href: "/cities/rochester-mn" },
    { name: "Duluth", href: "/cities/duluth-mn" },
    { name: "Sartell", href: "/states/minnesota" },
    { name: "St. Joseph", href: "/states/minnesota" },
  ],
  introTitle: "Emergency & Expedited Passport Services in St. Cloud",
  introDescription: "Fast, reliable passport processing for St. Cloud and central Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local St. Cloud and central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "St. Cloud Main Post Office",
      address: "28 5th Ave S, St. Cloud, MN 56301",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(320) 251-1401",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for St. Cloud and Stearns County.",
    },
    {
      name: "Sartell Post Office",
      address: "109 1st St S, Sartell, MN 56377",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(320) 251-5843",
      notes: "Convenient for Sartell and northern St. Cloud residents. Passport photos available. Call ahead for appointment availability.",
    },
    {
      name: "Sauk Rapids Post Office",
      address: "1001 1st St S, Sauk Rapids, MN 56379",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(320) 251-5443",
      notes: "Serves Sauk Rapids and Benton County residents. Call ahead for appointment availability.",
    },
    {
      name: "Little Falls Post Office",
      address: "100 1st St SE, Little Falls, MN 56345",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(320) 632-6664",
      notes: "Primary acceptance facility for Little Falls and northern Morrison County residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — St. Cloud", address: "2025 Division St, St. Cloud, MN 56301", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — St. Cloud", address: "2510 W Division St, St. Cloud, MN 56301", hours: "Call for hours" },
    { name: "The UPS Store — St. Cloud", address: "4101 2nd St S, St. Cloud, MN 56301", hours: "Call for hours" },
    { name: "Walgreens — Sartell", address: "106 1st St S, Sartell, MN 56377", hours: "Call for hours" },
    { name: "CVS Pharmacy — Little Falls", address: "1001 1st Ave SE, Little Falls, MN 56345", hours: "Daily 7 AM – 10 PM" },
    { name: "Walmart — St. Cloud", address: "3601 2nd St S, St. Cloud, MN 56301", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — St. Cloud",
      address: "St. Cloud area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Stearns County Service Center",
      address: "St. Cloud, MN 56301",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Stearns County option. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 70 miles from St. Cloud — 1 hour 15 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for the Twin Cities and central Minnesota. Nonstop service to major international hubs.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "STC",
      name: "St. Cloud Regional Airport",
      distance: "St. Cloud, MN — local airport",
      address: "1550 45th Ave SE, St. Cloud, MN 56304",
      note: "Regional airport with domestic flights. For international travel, MSP is the primary hub.",
      flightUrl: "https://www.stcloudairport.com/",
      flightLabel: "St. Cloud Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP — Minneapolis-Saint Paul International Airport",
      subtitle: "Primary gateway for St. Cloud international travelers",
      content:
        "MSP is the primary departure point for St. Cloud's international travelers. Located about 70 miles southeast via I-94, it offers nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik. Most St. Cloud residents drive to MSP for international flights, making the airport accessibility a key factor in travel planning.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "St. Cloud State University & Study Abroad",
      subtitle: "Students, faculty, and international scholars",
      content:
        "St. Cloud State University sends hundreds of students abroad each semester through study abroad programs, research collaborations, and international internships. Many students receive their acceptance letter with only 3–6 weeks before departure, creating an urgent need for expedited passports.",
      tip: "Students should apply for or renew their passport at the same time they apply for study abroad programs. Processing delays can jeopardize your placement.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Central Minnesota Manufacturing & Business",
      subtitle: "International clients, trade shows, and supplier visits",
      content:
        "St. Cloud's manufacturing sector includes medical device companies, food processors, and industrial equipment manufacturers. These businesses have international clients and suppliers, creating a steady stream of business travelers who need expedited passports for trade shows, client visits, and quality inspections.",
      tip: "Business travelers should check passport expiration at the start of each quarter. Set calendar reminders for the entire team.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Family & Heritage Travel",
      subtitle: "Visiting family abroad, cultural events, and reunions",
      content:
        "St. Cloud's diverse community includes many families who travel to visit relatives abroad. These trips are often planned around school schedules, holidays, and family events. Children's passports are only valid for 5 years, and many families discover expiration issues close to departure.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months in advance.",
      icon: "ri-parent-line",
    },
  ],
  destinations: [
    {
      name: "India",
      context: "Family visits, cultural events, and heritage travel for central Minnesota families",
      urgency: "Family travel often planned around school schedules and holidays",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Manufacturing trade shows, business conferences, and supplier visits",
      urgency: "Conference schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico & Caribbean",
      context: "Family cruises, spring break trips, and winter escapes",
      urgency: "Last-minute cruise deals and resort packages happen 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Spain",
      context: "St. Cloud State study abroad programs and academic research",
      urgency: "Study abroad acceptance often comes with 3–6 weeks before departure",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Winnipeg shopping, Ontario fishing, and northern cabin visits",
      urgency: "Summer travel and hunting trips peak May through September",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Italy",
      context: "Heritage tourism, Mediterranean cruises, and academic conferences",
      urgency: "Cruise departures and conference schedules are fixed",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "40%",
      label: "of St. Cloud expedited requests are student study abroad or family travel discovered within 4 weeks of departure",
    },
    {
      stat: "3–5 Weeks",
      label: "average notice St. Cloud travelers have before a planned international trip",
    },
    {
      stat: "May–Aug",
      label: "peak season when study abroad departures, summer vacations, and family visits coincide",
    },
    {
      stat: "72 Hours",
      label: "shortest emergency turnaround we have accommodated for a St. Cloud student",
    },
  ],
  vitalRecords: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Minnesota Department of Health Vital Records. Online, mail, or in-person options available for Stearns County births.",
      url: "https://www.health.state.mn.us/people/vitalrecords/"
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Minnesota Department of Health Vital Records. Required for estate, legal, and survivor benefit matters.",
      url: "https://www.health.state.mn.us/people/vitalrecords/"
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from Stearns County Vital Records. Required for name change passport applications. Serving St. Cloud and all Stearns County communities.",
      url: "https://www.stearnscountymn.gov/"
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Stearns County District Court. Required for name change passport corrections and legal documentation.",
      url: "https://www.mncourts.gov/"
    }
  ],
};

export default function StCloudPage() {
  return <CityPage data={data} />;
}